import { useAuth0 } from "@auth0/auth0-react";
import styles from "./groupcard.module.css";
import { Dropdown } from "react-bootstrap";
import { Edit, MoreVertical, Trash2 } from "react-feather";
import { Link } from "react-router-dom";

const GroupCard = ({ item, setDeleteModalOpen, setSelectecId, setEditModalOpen, setEditUserData }) => {
    const { user, isAuthenticated } = useAuth0();

    return (<Link className={`${styles.ProspectCard}`} to={`/communication/campaign-groups/${item.id}`}>
        <div className={`${styles.ProspectCardUnder}`}>
            <div className={`${styles.ProspectCardHeadSection}`}>
                {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("campaign-group:update") > -1 || user["https://propertydek.com/permissions"].indexOf("campaign-group:delete") > -1) && <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                    <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                        <MoreVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className={`${styles.ActionsBUList}`}>
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("campaign-group:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditModalOpen(true); setEditUserData(item); }}>
                            <Edit /> Edit
                        </Dropdown.Item>}
                        {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("campaign-group:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalOpen(true); setSelectecId(item.id); }}>
                            <Trash2 /> Delete
                        </Dropdown.Item>}
                    </Dropdown.Menu>
                </Dropdown>}

                <div className={`${styles.ProsIMGSec}`}>
                    <img src="/static/img/group-users.svg" alt="" />
                </div>
                <div className={`${styles.HeadConSec}`}>
                    <p className={`${styles.ProsUserName}`}>
                        <span className={`${styles.UserName}`}>{item?.title}</span>
                    </p>
                    <p className={`${styles.ProsUserName} ${styles.Small}`}><span className={`${styles.HighListText}`}>{item?.no_of_contacts}</span> Contacts Available</p>
                </div>
            </div>
            <div className={`${styles.ProspectCardFootSec}`}>
                <span className={`${styles.PublishBadge}`}>{item?.type}</span>
            </div>
            {/* <div className={`${styles.ProspectCardBodySec}`}>
                <ul>
                    <li>
                        <p className={`${styles.Title}`}>Type:</p>
                        <p className={`${styles.Content}`}>{item?.type}</p>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}>No of contacts:</p>
                        <p className={`${styles.Content}`}>{item?.no_of_contacts}</p>
                    </li>
                </ul>
            </div> */}
        </div>
    </Link>);
}

export default GroupCard;